import styled from '@emotion/styled';
import React from 'react';

const StyledAddonsWrapper = styled.div`
	.dmlp__conti-upgrade__cta {
		box-shadow: none;
	}
`;

const AddonsUpgrade = ({
	brand = '',
	country,
	handleAddonsUpgrade,
	promoCode,
	type,
	addonsTitle,
}) => {
	return (
		<StyledAddonsWrapper>
			<div className='dmlp__member-checkout dmlp__addons-upgrade position-relative'>
				<div>
					<h4 className='font-weight-bold mt-0 mb-20 text-center'>
						{addonsTitle ? addonsTitle : `Add 2 Premium ${type}`}
					</h4>

					<div className='mb-30'>
						<img
							src={`/images/${country.toLowerCase()}/en/brands/${brand}/offer/${promoCode}/addon_${type}.jpg`}
							alt={addonsTitle ? addonsTitle : `Add 2 Premium ${type}`}
							title={addonsTitle ? addonsTitle : `Add 2 Premium ${type}`}
							className='w-100 d-block'
						/>
					</div>
				</div>

				<div className='dmlp__conti-upgrade__cta dmlp__unlimited-upgrade__cta'>
					<button
						type='button'
						className={'btn btn-primary w-100 mb-12 ' + brand}
						onClick={() => handleAddonsUpgrade(true)}
					>
						Add to Order
					</button>
					<div
						className={
							'btn btn-outline-secondary btn-block bg text-center p-12 ' + brand
						}
						onClick={() => handleAddonsUpgrade(false)}
					>
						No thanks, continue to checkout
					</div>
				</div>
			</div>
		</StyledAddonsWrapper>
	);
};

export default AddonsUpgrade;
